import { ProfiledDoctorsList } from '@/widgets/DoctorProfileList';
import type { IDoctor, IDoctorSkill } from '@/entities/doctor/model/types';
interface DoctorRecommendationsProps {
  recommendedDoctors: IDoctor[];
  currentSkill: IDoctorSkill | null;
}
export const DoctorRecommendation: React.FC<DoctorRecommendationsProps> = ({
  recommendedDoctors = [],
  currentSkill
}) => {
  if (!recommendedDoctors || recommendedDoctors.length === 0) {
    return null;
  }
  return <ProfiledDoctorsList doctors={recommendedDoctors} visibleSkill={currentSkill} data-sentry-element="ProfiledDoctorsList" data-sentry-component="DoctorRecommendation" data-sentry-source-file="DoctorRecommendation.tsx" />;
};